import api from './api';
import { ENDPOINTS } from '../utils/constants';
import { formatApiError, logError } from '../utils/errorHandler';

export const getMillEmails = async () => {
  try {
    const response = await api.get(ENDPOINTS.MILL_EMAILS.EMPLOYEE.LIST);
    return response.data.results ?? response.data;
  } catch (error) {
    logError('Get mill emails', error);
    throw formatApiError(error);
  }
};

export const sendMillEmail = async ({ sessionId, customerIds, customMessage }) => {
  try {
    const response = await api.post(ENDPOINTS.MILL_EMAILS.EMPLOYEE.SEND, {
      session_id: sessionId,
      customer_ids: customerIds,
      custom_message: customMessage,
    });
    return response.data;
  } catch (error) {
    logError('Send mill email', error);
    throw formatApiError(error);
  }
};

export const sendReminderMillEmail = async ({ sessionId, customerIds, subject, customMessage }) => {
  try {
    const response = await api.post(ENDPOINTS.MILL_EMAILS.EMPLOYEE.REMIND, {
      session_id: sessionId,
      customer_ids: customerIds,
      subject,
      custom_message: customMessage,
    });
    return response.data;
  } catch (error) {
    logError('Send reminder mill email', error);
    throw formatApiError(error);
  }
};

export const sendTestMillEmail = async ({ sessionId, testEmail, customMessage, type, subject }) => {
  try {
    const response = await api.post(ENDPOINTS.MILL_EMAILS.EMPLOYEE.TEST, {
      session_id: sessionId,
      test_email: testEmail,
      custom_message: customMessage,
      type,
      subject,
    });
    return response.data;
  } catch (error) {
    logError('Send test mill email', error);
    throw formatApiError(error);
  }
};
